import { render, staticRenderFns } from "./AprovacaoCompraItemContent.vue?vue&type=template&id=4b8d19fd&"
import script from "./AprovacaoCompraItemContent.vue?vue&type=script&lang=js&"
export * from "./AprovacaoCompraItemContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports